//
//
//
//
//
//
//
//
//

import Icon from '../icon'

export default {
  components: {
    Icon
  },
  props: {
    value: Boolean,
    type: {
      type: String,
      default: 'default'
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/check-icon/index.vue